<script>
import options from "./ContactAdvisorBlock.options"
export default options
</script>

<template>
    <nyk-form
        :apiPath="apiPath"
        :antiForgeryToken="antiForgeryToken"
        :formElements="formElements"
        :queryParams="queryParams"
        :confirmationMessage="labels.confirmationMessage"
        :submitSuccessMessage="labels.submitSuccessMessage"
        :submitErrorMessage="labels.submitErrorMessage"
        :resetAfterSubmission="true"
        :queryParamFields="queryParamFields">
    </nyk-form>
</template>